define('notifications/trial-ending-non-marvel-notification/trial-ending-non-marvel-notification',['require','web-urls','mixpanel-helper','plugins/dialog','cookie-handler','tealium-utils'],function (require) {
    var webUrls = require('web-urls');
    var mixpanelHelper = require('mixpanel-helper');
    var dialog = require('plugins/dialog');
    var cookieHandler = require('cookie-handler');
    var tealiumUtils = require('tealium-utils');

    return function () {
        var self = this;

        self.subscribe = function () {
            var subscribeUrl = webUrls.get('buyUpgradeUrl');

            mixpanelHelper.trackLink(subscribeUrl, 'Non-Marvel expiring trial: Subscribe');
        };

        self.dismiss = function () {
            mixpanelHelper.track('Non-Marvel expiring trial: Dismiss');
            dialog.close(self);
        };

        self.show = function () {
            cookieHandler.setTime(60 * 60 * 1000, 'trial-modal-shown', 'true');
            mixpanelHelper.track('Non-Marvel expiring trial: Show');
            tealiumUtils.sendTealiumEvent('meetings', 'trial_expiration_modal');
            return dialog.show(this);
        };
    };
});

